import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getUserDetailsByUserId,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  getStudentStatusDetailsByUserId,
  payOnlinePayment,
  getAllCounsellingDetailByStudentId,
  getStudentFeesDetailByFeesTransactionMstId,
} from "../../actions";
import moment from "moment";
import Modal from "react-responsive-modal";
import NoImage from "../../img/no_image.jpg";
import _ from "lodash";
import { Link } from "react-router-dom";
// import numberToText from "number-to-text";
import numberToWord from "../../utils/numberToWord";
import TuitionFeesReceipt from "./TuitionFeesReceipt";
const keys = require("../../config/keys");

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allLanguagesData: [],
      allAchievementsData: [],
      tuitionFeesDetails: [],
      modelOpen: false,
      modelTuitionFees: false,
      modelPaymentGateway: false,
    };
  }
  makeOnlinePayment = (item) => {
    //console.log("item.CourseList", item.CourseList);
    var feesAmount = 0;
    var CourseIDS = "";
    // if (item.CoursewiseFees === 1) {
    //   feesAmount = item.CourseList.reduce((sum, item) => {
    //     return (sum = sum + item.CourseFees);
    //   }, 0);
    // } else {
    //   feesAmount = item.FormFees;
    // }
    item.CourseList.filter((i) => {
      return i.CoursewiseFormFeesPaidSts === 0;
    }).map((item) => {
      CourseIDS = CourseIDS + item.CourseID + "|";
    });
    if (CourseIDS.length > 0) {
      CourseIDS = CourseIDS.toString().substring(0, CourseIDS.length - 1);
    }
    feesAmount = item.PendingAmount;

    // console.log("CourseIDS", CourseIDS);
    var orderInfo = {
      admissionNo: item.AdmissionNo,
      name: this.props.userDetails.FullUserName,
      mobileNo: this.props.userDetails.StudMobNo,
      email: this.props.userDetails.Email,
      programApplied: item.CourseList.map((data) =>
        data.SyllabusName.trim()
      ).join(","),
    };
    var payRequest = {
      id: this.props.auth.paymentvendor[0].id,
      vpc_Amount: feesAmount,
      vpc_MerchTxnRef:
        this.props.auth.userId +
        "|" +
        item.AdmFormGroupId +
        "|" +
        item.afdId +
        "|" +
        item.AdmissionNo +
        "|1",
      vpc_OrderInfo:
        this.props.userDetails.FirstName +
        "_" +
        this.props.userDetails.StudMobNo, //JSON.stringify(orderInfo),
      // vpc_ReturnURL: "http://localhost:5000/payment", //"http://localhost:3001",//
      vpc_Version: 1,
      vpc_OrderInfo1: JSON.stringify(orderInfo),
      vpc_firstname: this.props.userDetails.FullUserName,
      vpc_email: this.props.userDetails.Email,
      vpc_udf1: this.props.userDetails.StudMobNo,

      // Commented & Added By Pinal Patel 06-May-2020
      // vpc_udf2: this.props.auth.userId,
      vpc_udf2: this.props.auth.userId + "|Admission Form Fees",

      vpc_udf3: item.AdmFormGroupId,
      vpc_udf4: CourseIDS,
      vpc_udf5: item.AdmissionNo,
      vpc_udf6: "1|" + CourseIDS,
      vpc_lastName: this.props.auth.clientCode,
    };
    //console.log("payRequest", payRequest);
    if (this.props.auth.paymentvendor.length === 1) {
      this.props.payOnlinePayment(payRequest);
    }
  };

  makePayTuitionFees = (item) => {
    //console.log("item", item);
    var orderInfo = {
      admissionNo: item.AdmissionNo,
      name: this.props.userDetails.FullUserName,
      mobileNo: this.props.userDetails.StudMobNo,
      email: this.props.userDetails.Email,
      programApplied: item.CourseName,
    };
    var payRequest = {
      id: this.props.auth.paymentvendor[0].id,
      vpc_Amount: item.FeesAmountWithoutSymbol,
      vpc_MerchTxnRef:
        item.Id +
        "|" +
        item.FormGroupId +
        "|" +
        item.AcYearId +
        "|" +
        item.AdmissionNo +
        "|2|" +
        item.CourseID,
      vpc_OrderInfo:
        this.props.userDetails.FirstName +
        "_" +
        this.props.userDetails.StudMobNo,
      vpc_Version: 1,
      vpc_OrderInfo1: JSON.stringify(orderInfo),
      vpc_firstname: this.props.userDetails.FullUserName,
      vpc_email: this.props.userDetails.Email,
      vpc_udf1: this.props.userDetails.StudMobNo,

      // Commented & Added By Pinal Patel 06-May-2020
      // vpc_udf2: this.props.auth.userId,
      vpc_udf2: this.props.auth.userId + "|Admission Tution Fees",

      vpc_udf3: 0,
      vpc_udf4: 0,
      vpc_udf5: item.AdmissionNo,
      vpc_udf6: "2",
      vpc_lastName: this.props.auth.clientCode,
      vpc_TuitionFees: 1,
    };
    if (this.props.auth.paymentvendor.length) {
      this.props.payOnlinePayment(payRequest);
    }
  };

  onOpenModal = (AdmFormGroupId) => {
    this.setState({ modelOpen: true, receiptAdmFormGroupId: AdmFormGroupId });
  };
  onCloseModal = () => {
    this.setState({ modelOpen: false });
  };
  onOpenPaymentGatewayModal = (item) => {
    this.setState({ modelTuitionFees: true });
  };
  onClosePaymentGatewayModal = () => {
    this.setState({ modelTuitionFees: false });
  };

  onOpenTuitionFeesModal = async (item) => {
    //console.log(item);
    if (item.CntrlAStdId) {
      await this.props.getStudentFeesDetailByFeesTransactionMstId(
        item.FeesTranMstId
      );
    }
    await this.setState({
      tuitionFeesDetails: this.props.admissionTuitionFeesDetails,
      tuitionFeesAdmNo: item.AdmissionNo,
    });
    if (this.state.tuitionFeesDetails.length > 0) {
      this.setState({
        modelTuitionFees: true,
      });
    }
  };
  onCloseTuitionFeesModal = () => {
    this.setState({ modelTuitionFees: false });
  };

  // async componentWillMount() {
  //   this.props.getUserDetailsByUserId(this.props.auth.userId);
  //   this.props.getAllCounsellingDetailByStudentId(this.props.auth.userId);
  //   await this.props.getStudentStatusDetailsByUserId(this.props.auth.userId);
  //   await this.props.getAchievementsByStudentId(this.props.auth.userId);
  //   await this.props.getLanguageknownsByStudentId(this.props.auth.userId);
  //   if (this.props.admissionStudentStatusDetails.length > 0) {
  //     await this.setState({
  //       admissionNo: this.props.admissionStudentStatusDetails[0].AdmissionNo,
  //       acadYearId: this.props.admissionStudentStatusDetails[0].AcadYearId
  //     });
  //   }
  //   await this.setState({
  //     allAchievementsData: this.props.achievementByStudent,
  //     allLanguagesData: this.props.languageKnownByStudent
  //   });
  // }

  async componentWillMount() {
    this.props.getUserDetailsByUserId(this.props.auth.userId);

    // this.props.getAllCounsellingDetailByStudentId(0, this.props.auth.userId);
    this.props.getAllCounsellingDetailByStudentId(
      0,
      this.props.auth.userId,
      this.props.auth.admissionConfig.AyId
    );

    const PromiseArry = [
      // this.props.getStudentStatusDetailsByUserId(this.props.auth.userId),
      this.props.getStudentStatusDetailsByUserId(
        this.props.auth.userId,
        this.props.auth.admissionConfig.AyId
      ),

      this.props.getAchievementsByStudentId(this.props.auth.userId),
      this.props.getLanguageknownsByStudentId(this.props.auth.userId),
    ];

    await Promise.all(PromiseArry);

    if (this.props.admissionStudentStatusDetails.length > 0) {
      await this.setState({
        admissionNo: this.props.admissionStudentStatusDetails[0].AdmissionNo,
        acadYearId: this.props.admissionStudentStatusDetails[0].AcadYearId,
      });
    }
    await this.setState({
      allAchievementsData: this.props.achievementByStudent,
      allLanguagesData: this.props.languageKnownByStudent,
    });
  }

  printPaymentReceipt = () => {
    window.print();
  };

  render() {
    return (
      <div className="container dashboard-boxFixed">
        {/* Admission Form Fees Receipt Details Modal  */}
        <Modal
          open={this.state.modelOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={true}
          closeOnEsc={false}
          classNames={{
            modal: "modelOf90Percentage modaleReceiptView",
          }}
        >
          <div className="modal-content">
            <div className="modal-header no_print">
              <h5 className="modal-title">Print Receipt</h5>
            </div>
            <div className="modal-text">
              {this.props.admissionStudentStatusDetails
                .filter((i) => {
                  return (
                    i.AdmFormGroupId ===
                    parseInt(this.state.receiptAdmFormGroupId, 10)
                  );
                })
                .map((item, index) => {
                  return (
                    <div className="print-payment-receipt" key={index}>
                      <div className="row mb-3">
                        <div className="col-sm-12 printPaySlip">
                          <p className="text-center">
                            <strong>[Institution Copy]</strong>
                          </p>
                          <div className="printPaySlip mb-3">
                            <h5 className="inner-title mb-3 mt-0">
                              {keys.websiteSetting.PaymetnAcknowledgement}
                            </h5>
                          </div>
                        </div>
                        <div className="col-lg-12 printPaySlipReciept">
                          <div className="row">
                            <div className="col-lg-7 col-print-7 printPaySlip">
                              <p>
                                <strong>Application No</strong> :{" "}
                                {item.AdmissionNo || ""}
                              </p>
                              <p>
                                <strong>Date</strong> :{" "}
                                {moment(item.AdmissionDate).format(
                                  "DD-MM-YYYY"
                                ) || ""}
                              </p>
                              <p>
                                <strong>Amount(Rs)</strong> :{" "}
                                {item.PaidAmount ? `(₹${item.PaidAmount})` : ""}
                              </p>
                              {/* {item.CoursewiseFees === 1 ? (
                                <p>
                                  <strong>Amount(Rs)</strong> :
                                  {item.CourseList.reduce((sum, item) => {
                                    return (sum = sum + item.CourseFees);
                                  }, 0)
                                    ? `₹${item.CourseList.reduce(
                                        (sum, item) => {
                                          return (sum = sum + item.CourseFees);
                                        },
                                        0
                                      )}`
                                    : ""}
                                </p>
                              ) : (
                                <p>
                                  <strong>Amount(Rs)</strong> :{" "}
                                  {item.FormFees ? `(₹${item.FormFees})` : ""}
                                </p>
                              )} */}
                              <p>
                                <strong>Amount In Words</strong> :{" "}
                                <span className="text-capitalize">
                                  {numberToWord(item.PaidAmount) || ""} Only.
                                </span>
                              </p>
                              {/* {item.CoursewiseFees === 1 ? (
                                <p>
                                  <strong>Amount In Words</strong> :{" "}
                                  <span className="text-capitalize">
                                    {numberToWord(
                                      item.CourseList.reduce((sum, item) => {
                                        return (sum = sum + item.CourseFees);
                                      }, 0)
                                    )}{" "}
                                    Only.
                                  </span>
                                </p>
                              ) : (
                                <p>
                                  <strong>Amount In Words</strong> :{" "}
                                  {item.FormFees ? (
                                    <span className="text-capitalize">
                                      {numberToWord(item.FormFees) || ""} Only.
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </p>
                              )} */}
                              <div className="printPaySlip mb-2">
                                <div className="printprogram-list">
                                  <div>
                                    <strong>Prefered Programs</strong> :
                                    <p>
                                      {item.CourseList.filter((i) => {
                                        return (
                                          i.CoursewiseFormFeesPaidSts === 1
                                        );
                                      }).map((item, index) => {
                                        return (
                                          <span key={index}>
                                            {item.SyllabusName}
                                          </span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="printPaySlip mb-3">
                                <p className=" mb-1">
                                  <strong>Received With Thanks </strong> :
                                  <span className="print-username text-capitalize">
                                    {this.props.userDetails !== undefined &&
                                      this.props.userDetails.FullUserName}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-5 col-print-5">
                              <div className="printPaySlip">
                                <p className="mb-1">
                                  <strong>Bank Name : </strong>
                                </p>
                                <p className="mb-1">
                                  <strong>Ref No : </strong>
                                </p>
                                <p className="mb-1">
                                  <strong>Ref Date : </strong>
                                </p>
                                <p className="paymenttypelist mt-2">
                                  {/* <strong>Payment Mode : </strong> */}

                                  {/* <span>CASH</span> */}
                                  {keys.websiteSetting.signUpContent !==
                                    "nvu" && <span>CHEQUE</span>}
                                  <span>DD</span>
                                  {keys.websiteSetting.signUpContent !==
                                    "nvu" && <span>ONLINE</span>}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 mt-2 ">
                          <p>
                            <strong>Sign</strong>
                          </p>
                          <p className="mb-0">
                            <strong>For : </strong>
                            _______________________________________
                          </p>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-12 printPaySlip">
                          <p className="text-center">
                            <strong>[Student Copy]</strong>
                          </p>
                          <div className="printPaySlip mb-3">
                            <h5 className="inner-title mb-3 mt-0">
                              {keys.websiteSetting.PaymetnAcknowledgement}
                            </h5>
                          </div>
                        </div>
                        <div className="col-lg-12 printPaySlipReciept">
                          <div className="row">
                            <div className="col-lg-7 col-print-7 printPaySlip">
                              <p>
                                <strong>Application No</strong> :{" "}
                                {item.AdmissionNo || ""}
                              </p>
                              <p>
                                <strong>Date</strong> :{" "}
                                {moment(item.AdmissionDate).format(
                                  "DD-MM-YYYY"
                                ) || ""}
                              </p>
                              <p>
                                <strong>Amount(Rs)</strong> :{" "}
                                {item.PaidAmount ? `(₹${item.PaidAmount})` : ""}
                              </p>
                              {/* {item.CoursewiseFees === 1 ? (
                                <p>
                                  <strong>Amount(Rs)</strong> :
                                  {item.CourseList.reduce((sum, item) => {
                                    return (sum = sum + item.CourseFees);
                                  }, 0)
                                    ? `₹${item.CourseList.reduce(
                                        (sum, item) => {
                                          return (sum = sum + item.CourseFees);
                                        },
                                        0
                                      )}`
                                    : ""}
                                </p>
                              ) : (
                                <p>
                                  <strong>Amount(Rs)</strong> :{" "}
                                  {item.FormFees ? `(₹${item.FormFees})` : ""}
                                </p>
                              )} */}
                              <p>
                                <strong>Amount In Words</strong> :{" "}
                                <span className="text-capitalize">
                                  {numberToWord(item.PaidAmount) || ""} Only.
                                </span>
                              </p>
                              {/* {item.CoursewiseFees === 1 ? (
                                <p>
                                  <strong>Amount In Words</strong> :{" "}
                                  <span className="text-capitalize">
                                    {numberToWord(
                                      item.CourseList.reduce((sum, item) => {
                                        return (sum = sum + item.CourseFees);
                                      }, 0)
                                    )}{" "}
                                    Only.
                                  </span>
                                </p>
                              ) : (
                                <p>
                                  <strong>Amount In Words</strong> :{" "}
                                  {item.FormFees ? (
                                    <span className="text-capitalize">
                                      {numberToWord(item.FormFees) || ""} Only.
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </p>
                              )} */}
                              <div className="printPaySlip mb-2">
                                <div className="printprogram-list">
                                  <div>
                                    <strong>Prefered Programs</strong> :
                                    <p>
                                      {item.CourseList.filter((i) => {
                                        return (
                                          i.CoursewiseFormFeesPaidSts === 1
                                        );
                                      }).map((item, index) => {
                                        return (
                                          <span key={index}>
                                            {item.SyllabusName}
                                          </span>
                                        );
                                      })}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="printPaySlip mb-3">
                                <p className=" mb-1">
                                  <strong>Received With Thanks </strong> :
                                  <span className="print-username text-capitalize">
                                    {this.props.userDetails !== undefined &&
                                      this.props.userDetails.FullUserName}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-5 col-print-5">
                              <div className="printPaySlip">
                                <p className="mb-1">
                                  <strong>Bank Name : </strong>
                                </p>
                                <p className="mb-1">
                                  <strong>Ref No : </strong>
                                </p>
                                <p className="mb-1">
                                  <strong>Ref Date : </strong>
                                </p>
                                <p className="paymenttypelist mt-2">
                                  {/* <strong>Payment Mode : </strong> */}

                                  {/* <span>CASH</span> */}
                                  {keys.websiteSetting.signUpContent !==
                                    "nvu" && <span>CHEQUE</span>}
                                  <span>DD</span>
                                  {keys.websiteSetting.signUpContent !==
                                    "nvu" && <span>ONLINE</span>}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 mt-2 ">
                          <p>
                            <strong>Sign</strong>
                          </p>
                          <p className="mb-0">
                            <strong>For : </strong>
                            _______________________________________
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="col-lg-12 mt-2">
              <p className="mb-3 border-top pt-2">
                <strong>Note: </strong>
                <span>
                  For offline payment submit receipt along with cheque/DD at
                  Account section, Sumandeep Vidyapeeth and get it signed &amp;
                  sealed before the last date for application.
                </span>
              </p>
            </div>
            <div className="modal-footer no_print">
              <button
                type="submit"
                className="btn btn-success btn-lg theme-btn"
                onClick={() => this.printPaymentReceipt()}
              >
                <i className="fa fa-print " aria-hidden="true" /> Print Receipt
              </button>
            </div>
          </div>
        </Modal>

        {/* Tuition Fees Receipt Details Modal */}
        <Modal
          open={this.state.modelTuitionFees}
          onClose={this.onCloseTuitionFeesModal}
          closeOnOverlayClick={true}
          closeOnEsc={false}
          classNames={{
            modal: "modelOf90Percentage modaleReceiptView",
          }}
        >
          <div className="modal-content">
            <div className="modal-header no_print">
              <h5 className="modal-title">Print Receipt</h5>
            </div>
            <div className="modal-text">
              <TuitionFeesReceipt
                tuitionFeesDetails={this.state.tuitionFeesDetails}
                tuitionFeesAdmNo={this.state.tuitionFeesAdmNo}
              />
            </div>
            <div className="modal-footer no_print">
              <button
                type="submit"
                className="btn btn-success btn-lg theme-btn"
                onClick={() => this.printPaymentReceipt()}
              >
                <i className="fa fa-print " aria-hidden="true" /> Print Receipt
              </button>
            </div>
          </div>
        </Modal>

        {/* Payment List Modal */}
        <Modal
          open={this.state.modelPaymentGateway}
          onClose={this.onClosePaymentGatewayModal}
          closeOnOverlayClick={true}
          closeOnEsc={false}
          classNames={{
            modal: "modelOf90Percentage modaleReceiptView modelPayGetway",
          }}
        >
          <div className="modal-content">
            <div className="modal-header no_print">
              <h5 className="modal-title">Payment Gateway </h5>
            </div>
            <div className="modal-text">
              {this.props.auth.paymentvendor.length > 1 && (
                <div className="paymentGetwayList">
                  <ul>
                    {this.props.auth.paymentvendor.map((data, eIndex) => {
                      return (
                        <li key={eIndex}>
                          <input
                            type="radio"
                            id={data.vendorbank}
                            name="option"
                            //onChange={this.handleChangeAsAbove}
                          />
                          <label htmlFor={data.vendorbank}>
                            {data.vendorbank} PAY
                          </label>
                          {/* <button
                            type="submit"
                            className="btn btn-success btn-forGateway"
                            onClick={() => this.printPaymentReceipt()}
                          >
                            <i className="fa fa-print " aria-hidden="true" />{" "}
                            Pay
                            {data.vendorbank}
                          </button> */}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </Modal>

        <div className="main-bg dashboard-box">
          <div>
            <h2 className="page-title sub-title">Application Details</h2>
            <div className="row">
              <div className="col-lg-3 col-sm-4">
                <figure className="figureBlock">
                  <Link
                    to="/Account/StudentAccount/UserProfile"
                    className="userEdit"
                  >
                    <i className="fa fa-pencil-square-o" aria-hidden="true" />
                  </Link>

                  <div>
                    {this.props.userDetails.ProPic ? (
                      <img
                        src={
                          keys.ServicePath + this.props.userDetails.ProPic || ""
                        }
                        alt="profile"
                      />
                    ) : (
                      <img src={NoImage} alt="profile" />
                    )}
                  </div>
                  <div className="userDetails">
                    <h4 className="text-capitalize">
                      {this.props.userDetails.FullUserName}
                    </h4>
                    <ul>
                      <li>
                        <i className="fa fa-calendar" aria-hidden="true" />{" "}
                        {moment(this.props.userDetails.DOB).isValid()
                          ? moment(this.props.userDetails.DOB).format(
                              "DD-MM-YYYY"
                            )
                          : ""}
                      </li>
                      <li>
                        <i className="fa fa-envelope" aria-hidden="true" />{" "}
                        {this.props.userDetails.Email}
                      </li>
                      <li>
                        <i className="fa fa-phone-square" aria-hidden="true" />{" "}
                        {this.props.userDetails.StudMobNo}
                      </li>
                    </ul>
                  </div>

                  <div className="progress">
                    <div
                      className={
                        this.props.userDetails.IsFilled === 1
                          ? "progress-bar progress-bar-striped progress-bar-animated proB100"
                          : "progress-bar progress-bar-striped progress-bar-animated proB50"
                      }
                      role="progressbar"
                      aria-valuenow="75"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    />
                  </div>
                </figure>

                {keys.websiteSetting.signUpContent === "sud" && (
                  <div>
                    {this.props.admissionCounsellingDetail.length > 0 &&
                      _.sortBy(
                        this.props.admissionCounsellingDetail,
                        "CourseName"
                      ).map((item, index) => {
                        return (
                          <div className="card dashCounselling" key={index}>
                            <div className="card-header">
                              {item.FormGroupName}
                            </div>
                            <div className="card-body">
                              <p className="card-title">
                                <span>CourseName</span> : {item.CourseName}
                              </p>
                              <p className="card-title">
                                <span>FeesQuotaName</span> :{" "}
                                {item.FeesQuotaName}
                              </p>
                              <p className="card-text">
                                <span>CounselingStatus</span> :{" "}
                                {item.CounselingStatus === 1
                                  ? "Approved"
                                  : "Provisional Approved"}
                              </p>
                              <p className="card-text">
                                <span>FeesAmount</span> : {item.FeesAmount}
                              </p>

                              <div className="text-center mt-3">
                                {item.CntrlAStdId ? (
                                  <button
                                    className="btn no_print btn-lg btn-success theme-btn display-inline"
                                    type="button"
                                    onClick={() =>
                                      this.onOpenTuitionFeesModal(item)
                                    }
                                    disabled={
                                      item.CntrlAStdId !== null ? false : true
                                    }
                                  >
                                    <i
                                      className="fa fa-eye"
                                      aria-hidden="true"
                                    />
                                    View Receipt
                                  </button>
                                ) : item.IsTermFeesPaid ? (
                                  <button
                                    className="btn no_print btn-lg btn-success mr-0 theme-btn btnPayment display-inline btn-info"
                                    type="button"
                                    disabled={true}
                                  >
                                    <i
                                      className="fa fa-money"
                                      aria-hidden="true"
                                    />
                                    {keys.websiteSetting.signUpContent === "nvu"
                                      ? "Pay Tuition Fees"
                                      : "Pay Tuition Fees"}
                                  </button>
                                ) : (
                                  <button
                                    className="btn no_print btn-lg btn-success mr-0 theme-btn btnPayment display-inline btn-info"
                                    type="button"
                                    onClick={() =>
                                      this.makePayTuitionFees(item)
                                    }
                                  >
                                    <i
                                      className="fa fa-money"
                                      aria-hidden="true"
                                    />
                                    {keys.websiteSetting.signUpContent === "nvu"
                                      ? "Pay Tuition Fees"
                                      : "Pay Tuition Fees"}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>

              <div className="col-lg-9 col-sm-8 boxFixed-right">
                <div className="main-bg dashUserProgram">
                  {this.props.admissionStudentStatusDetails.length === 0 && (
                    <h4 className="mb-4">
                      You have not applied for any program{" "}
                      <Link
                        to="/Account/StudentAccount/AdmissionForm/0"
                        className="btn btn-success btn-md marg30 theme-btn float-right"
                      >
                        Apply Now{" "}
                        <i
                          className="fa fa-arrow-right mr-0"
                          aria-hidden="true"
                        />
                      </Link>
                    </h4>
                  )}
                  {this.props.admissionStudentStatusDetails.length > 0 && (
                    <div className="user">
                      <h4 className="mb-4">Program Applied For</h4>
                      {_.sortBy(
                        this.props.admissionStudentStatusDetails,
                        "AdmFormGroupId"
                      ).map((item, index) => {
                        return (
                          <div key={index}>
                            <div className="formListStatus">
                              <div className="clearfix mb-2">
                                {item.IsVerify === 1 && item.PaidAmount > 0 && (
                                  <div className="float-left stdPendingAmount">
                                    <span
                                      className="programReceipt"
                                      onClick={() =>
                                        this.onOpenModal(item.AdmFormGroupId)
                                      }
                                    >
                                      <i
                                        className="fa fa-eye"
                                        aria-hidden="true"
                                      />{" "}
                                      View Receipt
                                    </span>{" "}
                                    {item.PendingAmount > 0 &&
                                      item.PaidAmount > 0 && (
                                        <span className="Paid ">
                                          Paid {`(₹${item.PaidAmount})`}
                                        </span>
                                      )}
                                    {item.PendingAmount > 0 &&
                                      item.PaidAmount > 0 && (
                                        <span className="Paid Pending">
                                          Pending {`(₹${item.PendingAmount})`}
                                        </span>
                                      )}
                                  </div>
                                )}
                                <div className="float-right programpaid">
                                  {item.IsVerify === 1 &&
                                  item.IsFormFeesPaid === 1 &&
                                  item.PendingAmount === 0 ? (
                                    <span className="Paid">Paid</span>
                                  ) : (
                                    ""
                                  )}
                                  {item.IsVerify === 1 &&
                                  item.PendingAmount > 0 ? (
                                    <button
                                      className="btn no_print btn-lg btn-success mr-0 theme-btn btnPayment display-inline btn-info"
                                      type="button"
                                      onClick={() =>
                                        this.makeOnlinePayment(item)
                                      }
                                    >
                                      <i
                                        className="fa fa-money"
                                        aria-hidden="true"
                                      />{" "}
                                      {keys.websiteSetting.signUpContent ===
                                      "nvu"
                                        ? "Online Payment"
                                        : "Make Payment"}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="documentFormName">
                                <span>
                                  {index + 1 + "."} {item.FormName} {""}
                                  {item.CoursewiseFees === 1 ? (
                                    <small>
                                      {item.CourseList.reduce((sum, item) => {
                                        return (sum = sum + item.CourseFees);
                                      }, 0)
                                        ? `(₹${item.CourseList.reduce(
                                            (sum, item) => {
                                              return (sum =
                                                sum + item.CourseFees);
                                            },
                                            0
                                          )})`
                                        : ""}
                                    </small>
                                  ) : (
                                    <small>
                                      {item.FormFees
                                        ? `(₹${item.FormFees})`
                                        : ""}
                                    </small>
                                  )}
                                </span>
                                <div className="studentformStatus">
                                  <ul className="studentStatusprogressbar">
                                    <li
                                      className={
                                        item.FormVerified === 1
                                          ? "active verifyStatus"
                                          : "verifyStatus"
                                      }
                                    >
                                      Form Verification Status
                                    </li>
                                    <li
                                      className={
                                        item.feesPaid === 1
                                          ? "active formStatus"
                                          : "formStatus"
                                      }
                                    >
                                      Form Fees Status
                                    </li>
                                    <li
                                      className={
                                        item.DocumentVerifyStatus !== 2 &&
                                        item.feesPaid === 1 &&
                                        item.DocumentVerifyStatus
                                          ? "active docStatus"
                                          : "docStatus"
                                      }
                                    >
                                      Document Verification Status
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="courseListStatus">
                              {item.CourseList.map((course, index) => {
                                return (
                                  <div className="documentFormName" key={index}>
                                    <span>
                                      {index + 1 + "."} {course.SyllabusName}{" "}
                                      {item.CoursewiseFees === 1 && (
                                        <small>
                                          {course.CourseFees
                                            ? `(₹${course.CourseFees})`
                                            : ""}
                                        </small>
                                      )}
                                    </span>
                                    <div className="studentformStatus">
                                      <ul className="studentStatusprogressbar">
                                        <li
                                          className={
                                            course.CounselingSts === 1
                                              ? "active counStatus"
                                              : "counStatus"
                                          }
                                        >
                                          Counselling Status
                                        </li>
                                        <li
                                          className={
                                            course.CntrlAStdId > 0
                                              ? "active termFStatus"
                                              : "termFStatus"
                                          }
                                        >
                                          Tuition Fees Status
                                        </li>
                                        <li
                                          className={
                                            course.EnrolmentNo === 1
                                              ? "active enrolStatus"
                                              : "enrolStatus"
                                          }
                                        >
                                          Enrollment Number Status
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps({
  auth,
  userDetails,
  achievementByStudent,
  languageKnownByStudent,
  admissionStudentStatusDetails,
  admissionCounsellingDetail,
  admissionTuitionFeesDetails,
}) {
  return {
    auth,
    userDetails,
    achievementByStudent,
    languageKnownByStudent,
    admissionStudentStatusDetails,
    admissionCounsellingDetail,
    admissionTuitionFeesDetails,
  };
}
export default connect(mapStateToProps, {
  getUserDetailsByUserId,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  getStudentStatusDetailsByUserId,
  payOnlinePayment,
  getAllCounsellingDetailByStudentId,
  getStudentFeesDetailByFeesTransactionMstId,
})(Dashboard);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/Dashboard.js